import {Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name: 'quoteStatusStyle',
    pure: true
})
export class QuoteStatusStylePipe implements PipeTransform{
    transform(value: any, args?: any): any {
        let stringOut = '';
        const offerSent = 'offer_sent';
        const bidReceived = 'bid_received';
        const bidRejected = 'bid_rejected';
        const  actionRequired = 'action required';
        const  cancelled = 'cancelled';
        const accepted = 'accepted';
        const bidExpired = 'bid_expired';
        const rejected = 'rejected';
        const offerExpired = 'offer_expired';
        const bidPlaced = 'bid_placed';
        const offerReceived = 'offer_received';
        const orderPlaced = 'order placed';
        value = value.toLowerCase();
        if (value === actionRequired){
            stringOut = 'actionRequired';
        }else if (value === cancelled){
            stringOut = 'cancelled';
        }else if (value === accepted){
            stringOut = 'accepted';
        }else if (value === bidExpired){
            stringOut = 'bid-expired';
        }else if (value === rejected){
            stringOut = 'rejected';
        }else if (value === offerExpired){
            stringOut = 'offer-expired';
        }else if (value === bidPlaced){
          stringOut = 'bid-placed';
      }else if(value ===  offerSent){
        stringOut = 'offer-sent';
      }else if(value === bidRejected){
        stringOut = 'bid-rejected';
      }else if(value === bidReceived){
        stringOut = 'bid-received';
      }else if (value === offerReceived){
        stringOut = 'offer-received';
      }else if (value === orderPlaced){
        stringOut = 'order-placed';
    }
        return stringOut;
    }
}
